module.exports = __webpack_public_path__ + "static/media/1_A1_22.60c48968.png";